/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_WatchInputs */

const th_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับชม`)
};

const en_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch`)
};

const ja_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視聴`)
};

const zh_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观看`)
};

const es_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const pt_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistir`)
};

const id_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonton`)
};

const fr_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regarder`)
};

const tl_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoorin`)
};

const vi_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

const ko_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보기`)
};

const de_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const ru_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть`)
};

const tr_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzle`)
};

const it_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda`)
};

const pl_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oglądaj`)
};

const uk_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивитися`)
};

const hi_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देखें`)
};

const ar_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاهدة`)
};

const ms_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonton`)
};

const bn_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেখুন`)
};

const zh_tw2_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀看`)
};

const zh_hk2_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀看`)
};

const ur_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دیکھیں`)
};

const fa_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تماشا`)
};

const sw_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tazama`)
};

const nl_video_watch = /** @type {(inputs: Video_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijken`)
};

/**
* | output |
* | --- |
* | "Watch" |
*
* @param {Video_WatchInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_watch = /** @type {((inputs?: Video_WatchInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_WatchInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_watch(inputs)
	if (locale === "ja") return ja_video_watch(inputs)
	if (locale === "zh") return zh_video_watch(inputs)
	if (locale === "es") return es_video_watch(inputs)
	if (locale === "pt") return pt_video_watch(inputs)
	if (locale === "id") return id_video_watch(inputs)
	if (locale === "fr") return fr_video_watch(inputs)
	if (locale === "tl") return tl_video_watch(inputs)
	if (locale === "vi") return vi_video_watch(inputs)
	if (locale === "ko") return ko_video_watch(inputs)
	if (locale === "de") return de_video_watch(inputs)
	if (locale === "ru") return ru_video_watch(inputs)
	if (locale === "tr") return tr_video_watch(inputs)
	if (locale === "it") return it_video_watch(inputs)
	if (locale === "pl") return pl_video_watch(inputs)
	if (locale === "uk") return uk_video_watch(inputs)
	if (locale === "hi") return hi_video_watch(inputs)
	if (locale === "ar") return ar_video_watch(inputs)
	if (locale === "ms") return ms_video_watch(inputs)
	if (locale === "bn") return bn_video_watch(inputs)
	if (locale === "zh-TW") return zh_tw2_video_watch(inputs)
	if (locale === "zh-HK") return zh_hk2_video_watch(inputs)
	if (locale === "ur") return ur_video_watch(inputs)
	if (locale === "fa") return fa_video_watch(inputs)
	if (locale === "sw") return sw_video_watch(inputs)
	if (locale === "nl") return nl_video_watch(inputs)
	return en_video_watch(inputs)
});